import { type IErrorData } from '@/utils/getErrorData';

export const isError = (data: unknown): data is IErrorData => {
  return (
    data !== null &&
    typeof data === 'object' &&
    'message' in data &&
    typeof data.message === 'string'
  );
};
